import { render, staticRenderFns } from "./AppDownloadIcon.vue?vue&type=template&id=553dbc25&"
import script from "./AppDownloadIcon.vue?vue&type=script&lang=js&"
export * from "./AppDownloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports